import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { StatDisplaySkeleton } from 'app/agriculture/components/StatDisplay/StatDisplaySkeleton';
import { ContentLayout } from 'app/agriculture/components/ContentLayout/ContentLayout';

export function NetworkDisplaySkeleton() {
    return (
        <ContentBox.Section heading="Network Stats" disableDivider>
            <ContentLayout className="NetworkDisplay">
                <SimpleGrid columns={3}>
                    <StatDisplaySkeleton label="RSSI" />
                    <StatDisplaySkeleton label="Latency" />
                    <StatDisplaySkeleton label="Data Rate" />
                    <StatDisplaySkeleton label="Frequency" />
                    <StatDisplaySkeleton label="Transmission Power" />
                    <StatDisplaySkeleton label="Mac Address" />
                </SimpleGrid>
                <SimpleGrid columns={2}>
                    <StatDisplaySkeleton label="ipV6 Addresses" />
                    <StatDisplaySkeleton label="Network Addresses" />
                    <StatDisplaySkeleton label="Secondary Network Addresses" />
                    <StatDisplaySkeleton label="Peer Mac Addresses" />
                </SimpleGrid>
            </ContentLayout>
        </ContentBox.Section>
    );
}
